export default __webpack_public_path__ + "media/images/icons_fc/Chart_Gantt-6b2a243049be5dbeb717e4deb4ad5767.png";